export default __webpack_public_path__ + "static/media/Invitation-to-journal.d5b315e4.gif";